<template>
  <div class="address-modal">
    <CustomModal :show="show"
                 @close="onClose">
      <template #header>
        <h1 class="custom-modal__heading">
          Licence: add sites
        </h1>
      </template>

      <template #default>
        <div class="address-modal__body">
          <p>
            Add the schools who will receive this product,
            once all Sites have been added you will be able to go to Checkout.
          </p>
          <p>
            If you decide to add later, you will be able to add the sites at checkout.
          </p>

          <template v-if="loading">
            <loading-spinner></loading-spinner>
          </template>
          <template v-else>
            <div v-for="(orderLine, index) in orderLines"
                 :key="orderLine">
              <h2 class="address-modal__subheading">
                Site {{ index + 1 }}:
              </h2>
              <div v-if="!orderLineState[orderLine].saved"
                   class="address-modal__site-form">
                <OrgSearch v-model="orderLineState[orderLine].address"
                           class="address-modal__org-search"
                           :user-type="userType"
                           :show-validation="showValidation">
                </OrgSearch>

                <button class="btn btn-accent-8 btn-sm btn-rounded"
                        :disabled="!addressSelected( orderLine )"
                        @click="saveOrderLineAddress( orderLine )">
                  Save
                </button>
              </div>
              <div v-else
                   class="address-modal__site-summary">
                <div>
                  <template v-if="orderLineState[orderLine].addressSummary.name">
                    <strong>
                      {{ orderLineState[orderLine].addressSummary.name }}
                    </strong><br>
                  </template>

                  <template v-if="orderLineState[orderLine].addressSummary.addressLine1">
                    {{ orderLineState[orderLine].addressSummary.addressLine1 }}<br>
                  </template>

                  <template v-if="orderLineState[orderLine].addressSummary.addressLine2">
                    {{ orderLineState[orderLine].addressSummary.addressLine2 }}<br>
                  </template>

                  <template v-if="orderLineState[orderLine].addressSummary.addressLine3">
                    {{ orderLineState[orderLine].addressSummary.addressLine3 }}<br>
                  </template>

                  <template v-if="orderLineState[orderLine].addressSummary.town">
                    {{ orderLineState[orderLine].addressSummary.town }}<br>
                  </template>

                  <template v-if="orderLineState[orderLine].addressSummary.region">
                    {{ orderLineState[orderLine].addressSummary.region }}<br>
                  </template>

                  <template v-if="orderLineState[orderLine].addressSummary.postcode">
                    {{ orderLineState[orderLine].addressSummary.postcode }}<br>
                  </template>
                </div>
                <button class="btn btn-accent-8 btn-sm btn-rounded"
                        style="margin-top: 15px"
                        @click="orderLineState[orderLine].saved = false">
                  Edit
                </button>
              </div>
            </div>
          </template>
        </div>
      </template>

      <template #footer>
        <div class="address-modal__footer">
          <button v-if="allSaved || ( !allSaved && !noSkip )"
                  class="btn btn-accent-1"
                  @click="onClose">
            <span v-if="allSaved">
              Close
            </span>
            <span v-else>
              Add remaining sites later during checkout
            </span>
          </button>
        </div>
      </template>
    </CustomModal>
  </div>
</template>

<script>
import CustomModal from "~/Components/CustomModal.vue";
import OrgSearch from "~/Components/Forms/AddressSearch/OrgSearch.vue";
import LoadingSpinner from "~/Components/LoadingSpinner.vue";
import { getAddress, saveAddress } from "~/Scripts/resources/licenseResource";

export default {
  name: "DeliveryAddressModal",
  components: {
    CustomModal,
    OrgSearch,
    LoadingSpinner
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    searchTypeId: {
      type: String,
      default: null
    },
    orderLines: {
      type: Array,
      default: () => []
    },
    noSkip: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: true,
      userType: {
        searchTypeId: this.searchTypeId
      },
      showValidation: false,
      orderLineState: {}
    };
  },
  computed: {
    allSaved () {
      let result = false;

      if ( this.orderLineState ) {
        result = Object.values( this.orderLineState ).every( x => x.saved );
      }

      return result;
    }
  },
  watch: {
    orderLines: {
      deep: true,
      immediate: true,
      handler ( val ) {
        if ( val ) {
          val.forEach( x => {
            if ( !this.orderLineState[x] ) {
              this.$set( this.orderLineState, x, {
                saved: false,
                address: {},
                addressSummary: {}
              } );
            }
          } );
        }
      }
    },
    show ( val ) {
      if ( val ) {
        const promises = [];

        this.orderLines.forEach( x => {
          if ( x ) {
            const promise = getAddress( x )
              .then( ( response ) => {
                if ( response.data ) {
                  this.orderLineState[x].addressSummary = response.data;
                  this.orderLineState[x].saved = true;
                }
              } );

            promises.push( promise );
          }
        } );

        Promise.all( promises )
          .then( () => {
            this.loading = false;
          } );
      }
    }
  },
  methods: {
    saveOrderLineAddress ( id ) {
      const orgId = this.orderLineState[id].address.id;

      saveAddress( id, orgId )
        .then( ( response ) => {
          this.$set( this.orderLineState[id], "addressSummary", response.data );
          this.orderLineState[id].saved = true;
          this.$emit( "refresh-addresses" );
        } );
    },
    addressSelected ( id ) {
      let result = false;

      if ( this.orderLineState[id]?.address?.id ) {
        result = true;
      }

      return result;
    },
    onClose () {
      this.orderLineState = {};
      this.$emit( "close" );
    },
    selectClass ( model ) {
      return !model ? "select-placeholder" : "";
    },
    onSubmit () {
      this.onClose();
    }
  }
};
</script>

<style lang="less" scopped>
.hide-first-child {
  option:first-child {
    display: none;
  }
}

.select-placeholder {
  option {
    color: black;
  }
  color: #6c757d;
}

.address-modal {
  &__body {
    margin-bottom: 1rem;
  }

  &__site-summary {
    background: #e3f3ea;
    padding: 10px;
    margin-bottom: 15px;
    border-radius: 3px;
  }

  &__site-form {
    padding-bottom: 15px;
    border-bottom: 2px solid #003d3f;
    margin-bottom: 15px;

    /deep/ .org-search {
      margin-bottom: 0;
    }

    &:last-child {
      border-bottom: 0;
    }
  }

  &__org-search {
    margin-bottom: 2rem;
  }

  &__subheading {
    font-size: 18px;
  }
}
</style>
